import { NotificationContext } from "@app/notifications/NotificationContext"
import { useContext, useEffect } from "react";
import { ZipProjectContext } from "./ZipProjectContext";
import { Message, MessageType } from "@app/notifications";
import { ZipCodeAnalysisStatusChangeNotificationMessagePayload } from "@app/notifications/message";
import { ProjectRunStatusEnum } from "../enumerators";
import { ZipProjectActionsEnum } from "./interfaces";
import { isProjectRunning } from "./utility";

export const ZipProjectNotificationsContainer = (): void => {
  const notificationsContext = useContext(NotificationContext);
  const projectContext = useContext(ZipProjectContext);

  useEffect(() => {
    notificationsContext.subscribe(onNotificationReceived);

    return () => {
      notificationsContext.unsubscribe(onNotificationReceived);
    }
  });

  const onNotificationReceived = (message: Message) => {
    switch (message.notificationType) {
      case MessageType.ZipCodeAnalysisStatusChangeNotification:
        const payload = message.payload as ZipCodeAnalysisStatusChangeNotificationMessagePayload;
        if (payload.projectId === projectContext.state.project.projectId) {
          const updatedConfiguration = projectContext.state.project.projectRunConfigurations?.find((prc) => prc.projectRunConfigurationId === payload.projectRunConfigurationId);
          // if it's a new run configuration, or if the new status is succeeded
          if (!updatedConfiguration || payload.projectRunStatus === ProjectRunStatusEnum.Succeeded) {
            projectContext.onChangeProjectStatus(payload);

            // else if it's NOT a new configuration
          } else if (!!updatedConfiguration) {
            updatedConfiguration.status = payload.projectRunStatus;
            projectContext.dispatch({
              payload: {
                loading: false,
                project: {
                  ...projectContext.state.project,
                  isRunning: isProjectRunning(projectContext.state.project),
                },
                regionSetSpecialtyGroupToPartsLookup: projectContext.state.regionSetSpecialtyGroupToPartsLookup,
                runConfiguration: updatedConfiguration,
                selectedRows: projectContext.state.selectedRows,
                skip: projectContext.state.skip,
                zipDetails: projectContext.state.zipDetails,
              },
              type: ZipProjectActionsEnum.ChangeProjectStatus,
            })
          }
        }
        break;
    }
  }
}
